export default __webpack_public_path__ + "7553f304f7cb7163e5f5acfea051ff5d.svg";